import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';
import { HubioLoginService } from '@hubio/hubio-login';
import { environment } from 'src/environments/environment';
import { LoadingDisplayService } from '../services/loading-display.service';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '@core/components/modal/modal.component';
import { Router } from '@angular/router';

@Injectable()
export class HubioHttpInterceptor implements HttpInterceptor {
  private requestCount: number = 0;

  constructor(
    private auth: HubioLoginService,
    private loadingDisplay: LoadingDisplayService,
    private dialog: MatDialog,
    private router: Router,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.showSpinner();

    return next.handle(request).pipe(
      timeout(environment.HTTP_REQUEST_DURATION),
      catchError((err) => {
        if (err.name === 'TimeoutError') {
          this.openErrorDialog(err);
          return throwError(err);
        } else if (err.status === 401 || err.status === 403) {
          this.auth.logout();
          return throwError(err);
        } else {
          this.openErrorDialog(err);
          return throwError(err);
        }
      }),
      finalize(
        () => {
          this.stopSpinner();
        }
      )
    )
  }

  showSpinner(): void {
    this.requestCount++;
    this.loadingDisplay.show();
  }

  stopSpinner(): void {
    this.requestCount--;
    if (this.requestCount === 0) {
      this.loadingDisplay.hide();
    }
  }

  openErrorDialog(error: any) {
    console.error(error);
    const message = error?.error?.message ?? 'An unexpected error has occurred.'

    this.dialog.open(ModalComponent, {
      data: {
        title: "Error",
        message: [message]
      }
    }).afterClosed().toPromise().then(_ => {
      this.navigateToDashboard();
    });
  }

  private navigateToDashboard() {
    this.router.navigateByUrl(environment.HOMEPAGE_ROUTE);
  }
}
